var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 12.2,
    height: 13.2,
    stroke: "#4C65C0",
    strokeWidth: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 12.2,
    height: 3.2,
    stroke: "#4C65C0",
    strokeWidth: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 10.4,
    width: 12.2,
    height: 3.2,
    stroke: "#4C65C0",
    strokeWidth: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    x2: 3.5,
    y2: 4,
    stroke: "#4C65C0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 10,
    x2: 3.5,
    y2: 14,
    stroke: "#4C65C0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    x2: 6.5,
    y2: 4,
    stroke: "#4C65C0"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 10,
    x2: 6.5,
    y2: 14,
    stroke: "#4C65C0"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    x2: 9.5,
    y2: 4,
    stroke: "#4C65C0"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 10,
    x2: 9.5,
    y2: 14,
    stroke: "#4C65C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.3382V5.18685C5.5 5.10698 5.58901 5.05934 5.65547 5.10365L8.35662 6.90442C8.42051 6.94701 8.41455 7.04272 8.34587 7.07706L5.64472 8.42764C5.57823 8.46088 5.5 8.41253 5.5 8.3382Z",
    stroke: "#4C65C0",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtVideo);
export default __webpack_public_path__ + "static/media/extVideo.7b7b3907b0b465fabb95a45abc27acc1.svg";
export { ForwardRef as ReactComponent };